import { cn } from "@/lib/utils";
import { MessageEntity } from "@/indexedDB/types";
import { ChatType } from "@/server/types/chat";

import MessageBubble from "./MessageBubble";
import MessageSender from "./MessageSender";
import MessageAvatar from "./MessageAvatar";
import MessageReactions from "./reactions/MessageReactions";
import { useNavigationState } from "@/zustand/NavigationState";
import CommentCount from "./CommentCount";
// import MessageTimestamp from "./MessageTimestamp";

type Props = {
  message: MessageEntity;
  isFirstInGroup: boolean;
  isLastInGroup: boolean;
};

export default function MessageListItem({
  message,
  isFirstInGroup,
  isLastInGroup,
}: Props) {
  const chatType = useNavigationState((state) => state.activeChatType);
  const showGroupInfo = chatType === ChatType.GROUP && !message.isOutgoing;

  return (
    <div
      className={cn(
        "message-list-item px-2 py-[1px] lg:px-3",
        isFirstInGroup && "is-first-in-group",
        isLastInGroup && "is-last-in-group",
      )}
    >
      {showGroupInfo && isFirstInGroup && (
        <div className="mb-0.5 flex items-center gap-3">
          <MessageAvatar
            sender={message.sender}
            avatarId={message.avatarId || ""}
          />
          <MessageSender
            sender={message.sender}
            avatarId={message.avatarId || ""}
            senderDeleted={message.senderDeleted}
            className="font-bold text-primary"
          />
        </div>
      )}

      <div
        className={cn(
          "flex items-start justify-start gap-3",
          message.isOutgoing && "flex-row-reverse",
        )}
      >
        {showGroupInfo && <div data-testid="group-spacer" className="size-8" />}

        <div
          className={cn(
            // Mobile cap ~near-full-width (Telegram-style) so media bubbles ride
            // out wide; lg keeps a tighter cap. Text still hugs its content — the
            // cap only bounds fill-width content (media, long lines).
            "flex max-w-[85%] flex-col lg:max-w-[70%]",
            isLastInGroup && "pb-3",
          )}
        >
          <MessageBubble message={message} />

          <div
            className={cn(
              "mb-2 mt-1 flex w-full items-center gap-2",
              message.isOutgoing ? "justify-end" : "justify-start",
            )}
          >
            <CommentCount parentMessage={message} />

            <MessageReactions parentMessage={message} />
          </div>
        </div>
      </div>
    </div>
  );
}
